// Zweitasten-Kürzel `g h`, `g p` … (UX §2.9). Nie aktiv, solange der Fokus in einem Feld steht.
import { useEffect } from 'react';

export type GoTargets = Readonly<Record<string, () => void>>;

const isTyping = (target: EventTarget | null) =>
  target instanceof HTMLElement &&
  (target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName));

export function useGoShortcuts(targets: GoTargets, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    let armedUntil = 0;
    const onKey = (event: KeyboardEvent) => {
      if (event.metaKey || event.ctrlKey || event.altKey || isTyping(event.target)) return;
      const key = event.key.toLowerCase();
      if (key === 'g' && armedUntil === 0) {
        armedUntil = Date.now() + 1200;
        return;
      }
      if (armedUntil > 0) {
        const go = Date.now() <= armedUntil ? targets[key] : undefined;
        armedUntil = 0;
        if (go) {
          event.preventDefault();
          go();
        }
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [targets, enabled]);
}
